export default "__VITE_ASSET__69834c1b__"